module.exports = __webpack_public_path__ + "img/cover_pressalit_3.88047048.jpg";